(function () {
  function init(root) {
    if (!root || root.dataset.slInit) return;
    root.dataset.slInit = '1';

  var track = root.querySelector('[data-sl-track]');
  var prev = root.querySelector('[data-sl-prev]');
  var next = root.querySelector('[data-sl-next]');
  var progress = root.querySelector('[data-sl-progress]');
  var bar = progress ? progress.querySelector('i') : null;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sl-card]'));
  cards.forEach(function(card){
    card.style.setProperty('--d', card.getAttribute('data-sl-index'));
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('sl-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    cards.forEach(function(c){ io.observe(c); });
  } else {
    cards.forEach(function(c){ c.classList.add('sl-in'); });
  }

  function setOpen(card, open){
    card.classList.toggle('is-open', open);
    var m = card.querySelector('.sl-fy-more');
    if (m) m.setAttribute('aria-hidden', open ? 'false' : 'true');
    var t = card.querySelector('[data-sl-toggle]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  root.addEventListener('click', function(e){
    var card = e.target.closest ? e.target.closest('[data-sl-card]') : null;
    if (!card || !root.contains(card)) return;
    if (e.target.closest('[data-sl-toggle]')) { e.preventDefault(); e.stopPropagation(); setOpen(card, true); return; }
    if (e.target.closest('[data-sl-close]')) { e.preventDefault(); e.stopPropagation(); setOpen(card, false); return; }
    if (e.target.closest('a')) return;
    if (card.classList.contains('is-open')) return;
    var url = card.getAttribute('data-sl-url');
    if (url) window.location.href = url;
  });

  root.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var card = e.target.closest ? e.target.closest('[data-sl-card]') : null;
    if (!card || e.target !== card) return;
    if (card.classList.contains('is-open')) return;
    var url = card.getAttribute('data-sl-url');
    if (url) window.location.href = url;
  });

  function step(){
    if (!cards.length) return 340;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 18;
    return cards[0].getBoundingClientRect().width + gap;
  }
  if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });

  var ticking = false;
  function paint(){
    ticking = false;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) {
      if (progress) progress.style.display = 'none';
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }
    if (progress) progress.style.display = '';
    var p = Math.min(1, Math.max(0, track.scrollLeft / max));
    if (bar) bar.style.setProperty('--p', Math.max(0.06, p));
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }
  function onScroll(){
    if (!ticking) { ticking = true; requestAnimationFrame(paint); }
  }
  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  paint();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function(e){
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-sl-card]') : null;
      var c = el || (e.target.closest ? e.target.closest('[data-sl-card]') : null);
      if (c && root.contains(c)) c.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  }
  }
  function initAll(scope) {
    var selector = '[data-sl-encuentra]';
    if (scope.matches && scope.matches(selector)) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
